import { chatCompletionsUrl, chatErrorMessage } from "./client";
import { getSettings } from "../db";

export type TestConnectionOverrides = {
  ollamaApiUrl?: string;
  ollamaModel?: string;
  apiKey?: string;
};

export type TestConnectionResult = {
  ok: true;
  message: string;
};

export async function testAiConnection(
  overrides: TestConnectionOverrides = {},
): Promise<TestConnectionResult> {
  const saved = await getSettings();
  const url = chatCompletionsUrl(overrides.ollamaApiUrl ?? saved.ollamaApiUrl);
  const model = overrides.ollamaModel ?? saved.ollamaModel;
  const apiKey = overrides.apiKey !== undefined ? overrides.apiKey : saved.apiKey;

  const headers: Record<string, string> = { "Content-Type": "application/json" };
  if (apiKey) {
    headers.Authorization = `Bearer ${apiKey}`;
  }

  try {
    const res = await fetch(url, {
      method: "POST",
      headers,
      body: JSON.stringify({
        model,
        messages: [{ role: "user", content: "Reply with OK only" }],
        stream: false,
        max_tokens: 5,
        temperature: 0,
      }),
    });

    if (!res.ok) {
      const bodyText = await res.text().catch(() => "");
      throw new Error(chatErrorMessage(res.status, bodyText));
    }

    return { ok: true, message: "连接成功" };
  } catch (err) {
    if (err instanceof Error && (err.message.includes("API Key") || err.message.includes("AI 请求失败") || err.message.includes("请求过于频繁"))) {
      throw err;
    }
    throw new Error(
      "无法连接 AI 服务，请检查地址是否正确、服务是否运行，以及是否允许浏览器跨域访问（CORS）。",
    );
  }
}
